module.exports = __webpack_public_path__ + "img/right-arrow.34603190.svg";